import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-spinner fa-pulse" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import {
  onMounted,
  onBeforeUnmount,
  reactive,
  computed,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLoader',
  setup(__props) {

const header = reactive({
  $el: null as null | HTMLElement,
});
const minHeight = reactive({ value: null as number | null });
const minHeightPx = computed(() => (minHeight.value ? `min-height:${minHeight.value}px` : null));

const setMinHeight = () => {
  minHeight.value = window.innerHeight;

  if (header.$el) {
    minHeight.value -= header.$el.offsetHeight;
  }
};

onMounted(() => {
  header.$el = document.querySelector('header');
  window.addEventListener('resize', setMinHeight);
  window.addEventListener('load', setMinHeight);
  setMinHeight();
  for (let i = 100; i < 3000; i += 100) {
    setTimeout(setMinHeight, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setMinHeight);
  window.removeEventListener('load', setMinHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(minHeightPx))
    }, _hoisted_3, 4)
  ]))
}
}

})